import { useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { api, errorMessage } from "@/lib/api";

function Toggle({ label, hint, checked, onChange, tid }) {
  return (
    <label className="flex items-start justify-between gap-4 text-sm">
      <span><span className="text-slate-200">{label}</span><span className="block text-xs text-slate-500">{hint}</span></span>
      <Switch data-testid={tid} checked={checked} onCheckedChange={onChange} />
    </label>
  );
}

export function ProfilePrivacy({ p, onSaved }) {
  const [name, setName] = useState(p.display_name || "");
  const save = async (patch, msg) => {
    try { await api.patch("/auth/preferences", patch); toast.success(msg); onSaved(); } catch (e) { toast.error(errorMessage(e)); }
  };
  return (
    <section data-testid="profile-privacy" className="mt-6 rounded-2xl bg-[#151C2C] border border-[#26334D] p-5 space-y-4">
      <p className="text-xs uppercase tracking-[0.18em] text-slate-500">Profile & privacy</p>
      <div>
        <p className="text-sm text-slate-200">Profile name</p>
        <p className="text-xs text-slate-500">Shown instead of your real name on reviews, comments and your profile.</p>
        <div className="mt-2 flex gap-2">
          <input data-testid="profile-display-name-input" value={name} onChange={(e) => setName(e.target.value)} maxLength={30} placeholder="e.g. BeachHopper"
            className="flex-1 min-w-0 bg-[#0B0F19] border border-[#26334D] rounded-xl px-3 py-2 text-sm outline-none focus:border-[#FFB800]" />
          <Button data-testid="profile-display-name-save" onClick={() => save({ display_name: name }, "Profile name saved")}
            className="rounded-xl bg-[#FFB800] hover:bg-[#E6A600] text-[#0B0F19] font-semibold">Save</Button>
        </div>
      </div>
      <Toggle tid="profile-private-toggle" label="Private profile" hint="Only followers can see your profile page: photos, places and hearts. Reviews on places stay public."
        checked={p.private_profile} onChange={(on) => save({ private_profile: on }, on ? "Your profile is now private" : "Your profile is now public")} />
      <Toggle tid="profile-hide-avatar-toggle" label="Hide my picture" hint="Your profile picture won't be shown to anyone else, including followers."
        checked={p.hide_avatar} onChange={(on) => save({ hide_avatar: on }, on ? "Picture hidden" : "Picture visible")} />
      <Toggle tid="profile-visits-toggle" label="Show my past trip stops" hint="Adds places from past trips to Places visited."
        checked={p.public_visits} onChange={(on) => save({ public_visits: on }, "Saved")} />
    </section>
  );
}
